var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.259 54.896a2.637 2.637 0 0 0 1.864-4.501l-26.619-26.62a2.637 2.637 0 0 0-3.729 3.73l26.62 26.618c.514.515 1.189.773 1.864.773z",
    fill: "#FFB454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.123 54.123a2.63 2.63 0 0 1-1.864.773c-.675 0-1.35-.258-1.865-.773L23.775 27.504a2.637 2.637 0 0 1 0-3.729l30.348 30.348z",
    fill: "#FF8659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.996 39.997a2.637 2.637 0 0 0 2.518-1.854l3.232-10.397 10.397-3.231a2.637 2.637 0 0 0 .74-4.671l-8.89-6.287.14-10.886A2.637 2.637 0 0 0 25.919.524l-8.725 6.511L6.883 3.54a2.636 2.636 0 0 0-3.344 3.344l3.497 10.31L.524 25.92a2.637 2.637 0 0 0 2.147 4.213l10.887-.139 6.286 8.89a2.635 2.635 0 0 0 2.152 1.114z",
    fill: "#FFDD54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.455 88.455a5.273 5.273 0 0 0 0-7.457L56.76 49.302a2.637 2.637 0 0 0-3.729 0l-3.729 3.73a2.637 2.637 0 0 0 0 3.728l31.696 31.695a5.273 5.273 0 0 0 7.457 0z",
    fill: "#6B61B1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 31.64 39.551)",
    fill: "#FFB454"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.004 16.7h-2.637v-2.638a2.637 2.637 0 0 0-5.273 0V16.7h-2.637a2.637 2.637 0 0 0 0 5.274h2.637v2.636a2.637 2.637 0 0 0 5.273 0v-2.636h2.637a2.637 2.637 0 0 0 0-5.274z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.637,
    cy: 16.699,
    r: 2.637
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.73,
    cy: 2.637,
    r: 2.637
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 67.851 0)",
    fill: "#FFDD54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.062 29.883h-2.636v-2.637a2.637 2.637 0 0 0-5.274 0v2.637H3.516a2.637 2.637 0 0 0 0 5.273h2.636v2.637a2.637 2.637 0 0 0 5.274 0v-2.637h2.636a2.637 2.637 0 0 0 0-5.273zM26.367 5.273H23.73V2.637a2.637 2.637 0 0 0-5.273 0v2.636H15.82a2.637 2.637 0 0 0 0 5.274h2.637v2.637a2.637 2.637 0 0 0 5.273 0v-2.637h2.637a2.637 2.637 0 0 0 0-5.274z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.637,
    cy: 15.82,
    r: 2.637
  })), /*#__PURE__*/React.createElement("path", {
    d: "m27.746 27.746-3.232 10.397a2.637 2.637 0 0 1-4.67.74l-6.287-8.89-10.887.14A2.637 2.637 0 0 1 .523 25.92l6.512-8.726L3.54 6.884a2.637 2.637 0 0 1 .632-2.712l23.575 23.574z",
    fill: "#FFB454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.455 88.455a5.273 5.273 0 0 1-7.457 0L49.302 56.76a2.637 2.637 0 0 1 0-3.729l1.865-1.864 37.288 37.288z",
    fill: "#453D81"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.9ba7e28564188828ff0f1605e181c615.svg";
export { ForwardRef as ReactComponent };